import { Component, Input, SimpleChanges, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { TalentHappyPathDataService } from "../../service/talent-happy-path-data-service";
import {Countries} from "../../../../enums";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-talent-happy-path-footer',
  standalone: false,
  templateUrl: './talent-happy-path-footer.component.html',
  styleUrl: './talent-happy-path-footer.component.scss'
})
export class TalentHappyPathFooterComponent implements OnInit, OnChanges, OnDestroy {

  privacyPolicyUrlAquent: string = "https://aquent.com/privacy-policy";
  privacyPolicyUrlSkill: string = "https://skill.com/privacy-policy/";
  impressumUrl: string = "";
  modalIsHidden: boolean = true;
  countryId: number = -1;
  private destroy$ = new Subject<void>();

  @Input() postingInfo: PostingInfo;

  constructor(public dataService: TalentHappyPathDataService) {
  }

  ngOnInit() {
    if (this.postingInfo) {
      this.updatePolicyFromPosting(this.postingInfo);
    } else if (this.dataService.postingInfo) {
      this.updatePolicyFromPosting(this.dataService.postingInfo);
    } else if (this.dataService.talent?.countryId) {
      this.countryId = this.dataService.talent.countryId;
      this.getPrivacyPolicy(this.countryId);
    } else {
      this.countryId = this.getCountryIdFromBrowser();
      this.getPrivacyPolicy(this.countryId);
    }
  }

  private getCountryIdFromBrowser(): number {
    const locale = navigator.language || navigator.languages?.[0] || '';
    const [language, region] = locale.toLowerCase().split('-');

    // Match on region first (e.g. en-GB, en-AU), then fall back to the
    // language subtag for locales with no region (e.g. Chrome set to "ja").
    const regionToCountry: Record<string, number> = {
      'us': Countries.USA,
      'de': Countries.DE,
      'fr': Countries.FR,
      'jp': Countries.JP,
      'au': Countries.AU,
      'gb': Countries.UK,
      'nl': Countries.NL,
    };

    const languageToCountry: Record<string, number> = {
      'de': Countries.DE,
      'fr': Countries.FR,
      'ja': Countries.JP,
      'nl': Countries.NL,
    };

    return regionToCountry[region] ?? languageToCountry[language] ?? Countries.USA;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.postingInfo?.currentValue) {
      this.updatePolicyFromPosting(changes.postingInfo.currentValue);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updatePolicyFromPosting(postingInfo: any): void {
    if (postingInfo?.countryId) {
      this.countryId = postingInfo.countryId;
    } else if (this.dataService.talent?.countryId) {
      this.countryId = this.dataService.talent.countryId;
    }
    this.getPrivacyPolicy(this.countryId);
  }

  getPrivacyPolicy(countryId: number): void {
    this.impressumUrl = '';
    if (countryId) {
      switch (countryId) {
        case Countries.USA: {
          this.privacyPolicyUrlAquent = "https://aquent.com/privacy-policy";
          break;
        }
        case Countries.DE: {
          this.privacyPolicyUrlAquent = "https://aquent.de/privacy-policy/";
          this.impressumUrl = "https://aquent.de/impressum/";
          break;
        }
        case Countries.FR: {
          this.privacyPolicyUrlAquent = "https://aquent.fr/privacy-policy/";
          break;
        }
        case Countries.JP: {
          this.privacyPolicyUrlAquent = "https://aquent.co.jp/privacy-policy/";
          break;
        }
        case Countries.AU: {
          this.privacyPolicyUrlAquent = "https://aquent.com.au/privacy-policy";
          break;
        }
        case Countries.UK: {
          this.privacyPolicyUrlAquent = "https://aquent.co.uk/privacy-policy/";
          break;
        }
        case Countries.NL: {
          this.privacyPolicyUrlAquent = "https://aquent.nl/privacy-policy/";
          break;
        }
        default: {
          this.privacyPolicyUrlAquent = "https://aquent.com/privacy-policy";
        }
      }
    }
  }

}
